import { lazy } from 'react'

const HomePage = lazy(() => import('src/view/home/HomePage'))

const privateRoutes = [
  
].filter(Boolean)

const publicRoutes = [
  {
    path: '/',
    component: <HomePage />,
    allowsAuthenticatedUsers: true,
  },
  {
    path: '/:id',
    component: <HomePage />,
    allowsAuthenticatedUsers: true,
  },
].filter(Boolean)

const emptyPermissionsRoutes = [].filter(Boolean)

const simpleRoutes = [
  {
    path: '/403',
    loader: () => import('src/view/shared/errors/Error403Page'),
  },
  {
    path: '/404',
    loader: () => import('src/view/shared/errors/Error404Page'),
  },
  {
    path: '/500',
    loader: () => import('src/view/shared/errors/Error500Page'),
  },
  {
    path: '/ApplicationError',
    loader: () => import('src/view/shared/errors/ApplicationErrorPage'),
  },
  {
    path: '*/*',
    loader: () => import('src/view/shared/errors/Error404Page'),
  },
].filter(Boolean)

const routes = {
  privateRoutes,
  publicRoutes,
  emptyPermissionsRoutes,
  simpleRoutes,
}
export default routes
